import React from 'react';
import { Check } from 'lucide-react';
import { PROJECT_PIPELINE_STAGES } from '../constants/projectConstants';
import {
  resolveStatusForProjectStepper,
  isPipelineStageCompleted,
  getActivePipelineIndex
} from '../constants/projectPipelineStages';

export const ProjectDetailsStepper = ({ currentStatus, milestones, documentsStageComplete = false, teamAssigned = false, pmAssigned = false }) => {
  const stages = PROJECT_PIPELINE_STAGES;
  const resolved = resolveStatusForProjectStepper(currentStatus);
  const m = milestones || {};
  const extras = { documentsStageComplete, teamAssigned, pmAssigned };
  const activeIndex = getActivePipelineIndex(resolved, m, extras);

  return (
    <div className="bg-white rounded-xl border border-slate-100 py-4 overflow-x-auto no-scrollbar">
      <div className="flex items-start justify-between min-w-[1500px]">
        {stages.map((stage, index) => {
          let isCompleted = isPipelineStageCompleted(index, resolved, m, extras);
          let isActive = index === activeIndex;

          if (stage === 'Carpenter Complete') {
            if (m.carpenterProgress >= 100 || m.carpenter) isCompleted = true;
            if (!isCompleted && m.carpenterProgress > 0) isActive = true;
          }
          if (stage === 'Electrician Complete') {
            if (m.electricianProgress >= 100 || m.electrician) isCompleted = true;
            if (!isCompleted && m.electricianProgress > 0) isActive = true;
          }
          if (stage === 'Painter Complete') {
            if (m.painterProgress >= 100 || m.painter) isCompleted = true;
            if (!isCompleted && m.painterProgress > 0) isActive = true;
          }
          if (stage === 'Plumber Complete') {
            if (m.plumberProgress >= 100 || m.plumber) isCompleted = true;
            if (!isCompleted && m.plumberProgress > 0) isActive = true;
          }


          return (
            <div key={stage} className="flex flex-col items-center gap-3 flex-1 relative group">
              {index !== stages.length - 1 && (
                <div
                  className={`absolute top-4 left-[50%] w-full h-[2px] transition-colors duration-500 ${
                    isCompleted ? 'bg-emerald-400' : 'bg-slate-100'
                  }`}
                />
              )}

              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-[11px] font-extrabold z-10 transition-all duration-300 border-2 ${
                  isCompleted
                    ? 'bg-emerald-500 border-emerald-500 text-white'
                    : isActive
                      ? 'bg-[#2b448f] border-[#2b448f] text-white'
                      : 'bg-white border-slate-200 text-slate-300'
                }`}
              >
                {isCompleted ? <Check className="w-4 h-4 stroke-3" /> : index + 1}
              </div>

              <div className="flex flex-col items-center text-center max-w-[100px]">
                <span
                  className={`text-[9px] font-extrabold uppercase leading-tight tracking-tighter ${
                    isActive ? 'text-[#2b448f]' : isCompleted ? 'text-emerald-600' : 'text-slate-300'
                  }`}
                >
                  {stage}
                </span>
                {isActive && <div className="w-1 h-1 rounded-full bg-[#2b448f] mt-1 animate-pulse" />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
